// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__RiQbI"};